module.exports = __webpack_public_path__ + "img/theme3.21816d4d.png";